import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
var role = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).role : '';
var role_type = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).role_type : '';

Vue.use(Router)
export default new Router({
	//mode: 'history',
	routes: [{
			path: '*',
			redirect: '/vueadmin/index',
			hidden: true,
		},

		{
			path: '/vueadmin',
			name: '常用',
			url: '/vueadmin',
			iconCls: 'iconfont icon8', //图标样式class
			component: resolve => require(['../default'], resolve),
			children: [{
					iconCls: 'iconfont icon-e-home', //图标样式class
					path: 'index*',
					url: '/vueadmin/index',
					name: '首页',
					component: resolve => require(['../pages/index/index'], resolve),
					open: false,
					permission: []
				},
				{
					path: 'website*',
					url: 'website',
					name: '小程序官网',
					open: false,
					iconCls: 'iconfont icon-e-applet', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [{
							path: 'info-index*',
							url: '/vueadmin/website/info-index?type=1',
							name: '官网编辑',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/website/info/index'], resolve),
							permission: []
						},

						{
							path: 'article-lists*',
							url: '/vueadmin/website/article-lists',
							name: '企业动态',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/website/article/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/website/article-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/website/article-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/website/article-lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/website/article-lists/class'
							}, ],
						},
						{
							path: 'product-lists*',
							url: '/vueadmin/website/product-lists',
							name: '产品列表',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/website/product/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/website/product-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/website/product-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/website/product-lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/website/product-lists/class'
							}, ],
						},
						{
							path: 'product-create*',
							url: '/vueadmin/website/product-create',
							name: '产品新建',
							hidden:true,
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/website/product/create_edit'], resolve),
							permission: [ ],
						},
						{
							path: 'product-edit*',
							url: '/vueadmin/website/product-edit',
							name: '产品编辑',
							hidden:true,
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/website/product/create_edit'], resolve),
							permission: [ ],
						},

						{
							path: 'comment-lists*',
							url: '/vueadmin/website/comment-lists',
							name: '动态评论',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/website/article/comment_lists'], resolve),
							permission: [],
						},
						{
							path: 'article-create*',
							url: '/vueadmin/website/article-create',
							name: '新闻增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/website/article/create_edit'], resolve),
						}, {
							path: 'article-edit*',
							url: '/vueadmin/website/article-edit',
							name: '新闻修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/website/article/create_edit'], resolve),
						},
					]
				},
				{
					path: 'book*',
					url: 'book',
					name: '产品介绍页',
					open: false,
					iconCls: 'iconfont icon-e-instructionbook', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'article-lists*',
							url: '/vueadmin/book/article-lists',
							name: '产品介绍页',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/article/lists'], resolve),
							permission: [],
						},
						{
							path: 'article-create*',
							url: '/vueadmin/book/article-create',
							name: '新闻增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/article/create_edit'], resolve),
						}, {
							path: 'article-edit*',
							url: '/vueadmin/book/article-edit',
							name: '新闻修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/article/create_edit'], resolve),
						},
					]
				},
				{
					path: 'finance',
					url: 'finance',
					name: '财务',
					open: false,
					iconCls: 'iconfont icon-e-instructionbook', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'order*',
							url: '/vueadmin/finance/order',
							name: '订单统计',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/finance/order_lists'], resolve),
							permission: [],
						}
						
					]
				},

				{
					path: 'shop*',
					url: 'shop',
					name: '商城系统',
					open: false,
					iconCls: 'iconfont icon-e-shop', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
                        {
                        	path: 'count*',
                        	url: '/vueadmin/shop/count/order_lists?&searchType=today',
                        	name: '数据统计',
                        	iconCls: 'iconfont icon8', //图标样式class
                        	component: resolve => require(['../pages/shop/count/order_lists'], resolve),
                        	permission: [ ]
                        },
                        {
                        	path: 'sum*',
                        	url: '/vueadmin/shop/sum?&searchType=today',
                        	name: '采购单',
                        	iconCls: 'iconfont icon8', //图标样式class
                        	component: resolve => require(['../pages/shop/count/count'], resolve),
                        	permission: [ ]
                        },
                        {
							path: 'lists*',
							url: '/vueadmin/shop/product/lists',
							name: '产品管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/product/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/shop/product/lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/shop/product/lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/shop/product/lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/shop/product/lists/class'
							},
							{
								name: '分销配置',
								url: '/vueadmin/shop/product/dis'
							},
							{
								name: '团购配置',
								url: '/vueadmin/shop/product/group'
							},
							{
								name: '秒杀配置',
								url: '/vueadmin/shop/product/miaosha'
							},
							{
								name: '分享海报',
								url: '/vueadmin/shop/product/poster'
							},
							{
								name: '会员支付',
								url: '/vueadmin/shop/product/member_pay'
							},
							{
								name: '会员折扣',
								url: '/vueadmin/shop/product/member_discount'
							},

							]
						},

						{
							path: 'order-lists*',
							url: '/vueadmin/shop/order-lists?status=12',
							name: '商城订单',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/order/lists'], resolve),
							permission: [
							{
								name: '删除',
								url: '/vueadmin/shop/order-lists/del'
							}, 
							{
								name: '新建',
								url: '/vueadmin/shop/order-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/shop/order-lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/shop/order-lists/class'
							},
							{
								name: '不支付',
								url: '/vueadmin/shop/order-lists/pay'
							}, 
							 
							 ],
						},
						{
							path: 'printf-order-lists*',
							url: '/vueadmin/shop/printf-order-lists?status=12&printf=0',
							name: '商城订单(打印)',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/order/printf'], resolve),
							permission: [
							 ],
						},
						{
							path: 'print-hy*',
							url: '/vueadmin/shop/print-hy',
							name: 'A4打印',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/order/print-hy'], resolve),
							permission: [
							 ],
						},
						{
							path: 'coupon-lists*',
							url: '/vueadmin/shop/coupon-lists',
							name: '优惠券',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/coupon/lists'], resolve),
							permission: []
						},
						{
							path: 'group-lists*',
							url: '/vueadmin/shop/group-lists?status=0',
							name: '拼团管理',
							iconCls: 'iconfont icon8', //图标样式class
							hidden:true,
							component: resolve => require(['../pages/shop/group/info'], resolve),
							permission: []
						},
						{
							path: 'order-evaluate-lists*',
							url: '/vueadmin/shop/order-evaluate-lists',
							name: '订单评价',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/order/evaluate_lists'], resolve),
							permission: [],
						},
						{
							path: 'order-after-lists*',
							url: '/vueadmin/shop/order-after-lists',
							name: '订单售后',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/order/after_lists'], resolve),
							permission: [],
						},

						{
							path: 'coupon-create*',
							url: '/vueadmin/shop/coupon/coupon-create',
							name: '优惠券',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/coupon/create_edit'], resolve),
						},
						{
							path: 'order-info*',
							url: '/vueadmin/shop/order-info',
							name: '查看详情',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/order/info'], resolve),
						},
						{
							path: 'create*',
							url: '/vueadmin/shop/product/create',
							name: '产品增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/product/create_edit'], resolve),
						}, {
							path: 'edit*',
							url: '/vueadmin/shop/product/edit',
							name: '产品修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/product/create_edit'], resolve),
						},
					/*	{
							path: 'commission-order-lists*',
							url: '/vueadmin/shop/commission-order-lists',
							name: '员工订单',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/commission/order_lists'], resolve),
							permission: [],
						},
						{
							path: 'commission-lists*',
							url: '/vueadmin/shop/commission-lists',
							name: '员工佣金',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/commission/lists'], resolve),
							permission: [],
						},
						{
							path: 'commission-setting*',
							url: '/vueadmin/shop/commission-setting',
							name: '佣金设置',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/commission/staff_setting'], resolve),
							permission: [],
						},*/
						{
							path: 'poster-lists*',
							url: '/vueadmin/shop/poster-lists?type=1',
							name: '广告管理',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/poster/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/shop/poster-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/shop/poster-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/shop/poster-lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/shop/poster-lists/class'
							}, ],
						},


					]
				},
				{
					path: 'group*',
					url: 'group',
					name: '活动管理',
					open: false,
					iconCls: 'iconfont icon-e-instructionbook', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'lists*',
							url: '/vueadmin/group/lists',
							name: '团购管理',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/activity/group/lists'], resolve),
							permission: [],
						},
						{
							path: 'discount-lists*',
							url: '/vueadmin/group/discount-lists',
							name: '折扣管理',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/discount/lists'], resolve),
							permission: [],
						},
						{
							path: 'order/index*',
							url: '/vueadmin/group/order/index',
							name: '活动分析',
							hidden:true,
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/shop/activity/group/order/index'], resolve),
							permission: [],
						},
						{
							path: 'create*',
							url: '/vueadmin/group/create',
							name: '新闻增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/activity/group/create_edit'], resolve),
						}, {
							path: 'edit*',
							url: '/vueadmin/group/edit',
							name: '新闻修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/activity/group/create_edit'], resolve),
						},
						
						{
							path: 'discount-create*',
							url: '/vueadmin/group/discount-create',
							name: '新闻增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/discount/create_edit'], resolve),
						}, {
							path: 'discount-edit*',
							url: '/vueadmin/group/discount-edit',
							name: '新闻修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/discount/create_edit'], resolve),
						},
					]
				},
				
				

				{
					path: 'decorate*',
					url: 'decorate',
					name: '服务系统',
					open: false,
					iconCls: 'iconfont icon-e-system', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [

						{
							path: 'lists*',
							url: '/vueadmin/decorate/product/lists',
							name: '服务产品',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/product/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/decorate/product/lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/decorate/product/lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/decorate/product/lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/decorate/product/lists/class'
							}, ]
						},
						{
							path: 'order-lists*',
							url: '/vueadmin/decorate/order-lists?status=3',
							name: '服务订单',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/order/lists'], resolve),
							permission: [],
						},
						{
							path: 'order-after-lists*',
							url: '/vueadmin/decorate/order-after-lists?status=10',
							name: '订单售后',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/order/after_lists'], resolve),
							permission: [],
						},
						{
							path: 'order-evaluate-lists*',
							url: '/vueadmin/decorate/order-evaluate-lists',
							name: '订单评价(服务)',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/order/evaluate_lists'], resolve),
							permission: [],
						},

						{
							path: 'create*',
							url: '/vueadmin/shop/product/create',
							name: '产品增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/product/create_edit'], resolve),
						}, {
							path: 'edit*',
							url: '/vueadmin/shop/product/edit',
							name: '产品修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/product/create_edit'], resolve),
						},
						{
							path: 'article-lists*',
							url: '/vueadmin/decorate/article-lists',
							name: '企业动态',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/article/lists'], resolve),
							permission: [ ],
						},


						{
							path: 'poster-lists*',
							url: '/vueadmin/decorate/poster-lists?type=1',
							name: '服务广告管理',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/poster/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/decorate/poster-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/decorate/poster-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/decorate/poster-lists/edit'
							}, {
								name: '类别',
								url: '/vueadmin/decorate/poster-lists/class'
							}, ],
						},

						{
							path: 'order-info*',
							url: '/vueadmin/decorate/order-info?status=1',
							name: '订单详情',
							hidden:true,
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/order/info'], resolve),
							permission: [],
						},

							{
							path: 'comment-lists*',
							url: '/vueadmin/decorate/comment-lists',
							name: '动态评论',
							iconCls: 'iconfont icon12', //图标样式class
							component: resolve => require(['../pages/decorate/article/comment_lists'], resolve),
							permission: [],
						},
						{
							path: 'article-create*',
							url: '/vueadmin/decorate/article-create',
							name: '新闻增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/article/create_edit'], resolve),
						}, {
							path: 'article-edit*',
							url: '/vueadmin/decorate/article-edit',
							name: '新闻修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/article/create_edit'], resolve),
						},


					]
				},
				
				{
					path: 'cashier*',
					url: 'cashier',
					name: '在线开单',
					open: false,
					iconCls: 'iconfont icon-e-cashier', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'cashier-create*',
							url: '/vueadmin/cashier/cashier-create',
							name: '在线开单',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/cashier/create_edit'], resolve),
							permission: []
						},
				
					]
				},
				{
					path: 'merchant*',
					url: 'merchant',
					name: '商家管理',
					open: false,
					iconCls: 'iconfont icon-e-store', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'lists*',
							url: '/vueadmin/merchant/lists?status=0',
							name: '商家审核',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/merchant/lists'], resolve),
							permission: []
						},
						{
							path: 'product-lists*',
							url: '/vueadmin/merchant/product-lists?status=0',
							name: '产品审核',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/merchant/product/lists'], resolve),
							permission: []
						},
                        {
                        	path: 'product-create*',
                        	url: '/vueadmin/merchant/product-create',
                        	name: '产品新增或添加',
                            hidden:true,
                        	iconCls: 'iconfont icon8', //图标样式class
                        	component: resolve => require(['../pages/shop/merchant/product/create_edit'], resolve),
                        	permission: []
                        },
                        {
                        	path: 'product-edit*',
                        	url: '/vueadmin/merchant/product-edit',
                        	name: '产品新增或添加',
                            hidden:true,
                        	iconCls: 'iconfont icon8', //图标样式class
                        	component: resolve => require(['../pages/shop/merchant/product/create_edit'], resolve),
                        	permission: []
                        },
						{
							path: 'order-lists*',
							url: '/vueadmin/merchant/order-lists?status=3',
							name: '订单列表',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/merchant/order/lists'], resolve),
							permission: []
						},
						{
							path: 'in-lists*',
							url: '/vueadmin/merchant/in-lists',
							name: '商家收入',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/merchant/record/in/lists'], resolve),
							permission: []
						},
						{
							path: 'out-lists*',
							url: '/vueadmin/merchant/out-lists?status=0',
							name: '商家支出',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/merchant/record/out/lists'], resolve),
							permission: []
						},

					]
				},
				{
					path: 'teamHead*',
					url: 'teamHead',
					name: '团长管理',
					open: false,
					iconCls: 'iconfont icon-e-head', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'community/lists*',
							url: '/vueadmin/teamHead/community/lists',
							name: '社区管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/community/lists'], resolve),
							permission: []
						},
						{
							path: 'lists*',
							url: '/vueadmin/teamHead/lists?status=0',
							name: '团长管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/lists'], resolve),
							permission: []
						},
						{
							path: 'in-lists*',
							url: '/vueadmin/teamHead/in-lists',
							name: '团长佣金明细',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/record/in/lists'], resolve),
							permission: []
						},
						{
							path: 'out-lists*',
							url: '/vueadmin/teamHead/out-lists?status=0',
							name: '团长提现管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/record/out/lists'], resolve),
							permission: []
						},
						{
							path: 'sales*',
							url: '/vueadmin/teamHead/sales',
							name: '团长销售额统计',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/sales/lists'], resolve),
							permission: []
						},
						{
							path: 'detail*',
							url: '/vueadmin/teamHead/detail',
							hidden: true,
							name: '团长销售额统计',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/teamHead/sales/lists_detail'], resolve),
							permission: []
						},
					]
				},
				{
					path: 'ashopteamHead*',
					url: 'ashopteamHead',
					name: '商家管理',
					open: false,
					iconCls: 'iconfont icon-e-head', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'community/lists*',
							url: '/vueadmin/ashopteamHead/community/lists',
							name: '社区管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/community/lists'], resolve),
							permission: []
						},
						{
							path: 'lists*',
							url: '/vueadmin/ashopteamHead/lists?status=1',
							name: '商家管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/lists'], resolve),
							permission: []
						},
						{
							path: 'in-lists*',
							url: '/vueadmin/ashopteamHead/in-lists',
							name: '商家佣金明细',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/record/in/lists'], resolve),
							permission: []
						},
						{
							path: 'out-lists*',
							url: '/vueadmin/ashopteamHead/out-lists?status=0',
							name: '商家提现管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/record/out/lists'], resolve),
							permission: []
						},
						{
							path: 'sales*',
							url: '/vueadmin/ashopteamHead/sales',
							name: '商家销售额统计',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/sales/lists'], resolve),
							permission: []
						},
						{
							path: 'detail*',
							url: '/vueadmin/ashopteamHead/detail',
							hidden: true,
							name: '商家销售额统计',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/shopteamHead/sales/lists_detail'], resolve),
							permission: []
						},
					]
				},
				
				
				{
					path: 'eshopcashier*',
					url: 'eshopcashier',
					name: '商城开单',
					open: false,
					iconCls: 'iconfont icon-e-shop-cashier', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'eshopcashier-create*',
							url: '/vueadmin/eshopcashier/eshopcashier-create',
							name: '商城开单',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/cashier/create_edit'], resolve),
							permission: []
						},

					]
				},
				
				{
					path: 'package*',
					url: 'package',
					name: '服务套餐',
					open: false,
					iconCls: 'iconfont icon-e-package', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'lists*',
							url: '/vueadmin/package/lists',
							name: '套餐',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/package/lists'], resolve),
							permission: []
						},
						{
							path: 'create*',
							url: '/vueadmin/coupon/coupon/create',
							name: '套餐新增',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/package/create_edit'], resolve),
						},
						{
							path: 'order-lists*',
							url: '/vueadmin/package/order-lists?status=3',
							name: '套餐订单',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/package/order_lists'], resolve),
							permission: []
						},
						{
							path: 'order-record-lists*',
							url: '/vueadmin/package/order-record-lists?status=0',
							name: '扣次订单',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/package/order_record_lists'], resolve),
							permission: []
						},
					]
				},
				{
					path: 'user*',
					url: '/user',
					name: '会员管理',
					open: false,
					iconCls: 'iconfont icon-e-client', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
				
							path: 'lists*',
							url: '/vueadmin/user/lists?type=1',
							name: '会员列表',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/user/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/user/lists/del'
							}, ],
						},
						{
				
							path: 'lists*',
							url: '/vueadmin/user/lists?status=0',
							name: '会员列表(乐途)',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/user/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/user/lists/del'
							}, ],
						},
						{
										
							path: 'hysz-lists*',
							url: '/vueadmin/user/hysz-lists?status=0',
							name: '会员信息',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/user/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/user/lists/del'
							}, ],
						},
						{
				
							path: 'info*',
							url: '/vueadmin/user/info',
							name: '会员详情',
							iconCls: 'iconfont icon8', //图标样式class
							hidden: true,
							component: resolve => require(['../pages/user/info'], resolve),
						},
						{
				
							path: 'lev*',
							url: '/vueadmin/user/lev',
							name: '会员等级',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/user/lev/lists'], resolve),
							permission: [ ],
						},
				        {
				
				        	path: 'recharge*',
				        	url: '/vueadmin/user/recharge',
				        	name: '充值明细',
				        	iconCls: 'iconfont icon8', //图标样式class
				        	component: resolve => require(['../pages/user/recharge'], resolve),
				        	permission: [ ],
				        },
						{
							path: 'coupon-record*',
							url: '/vueadmin/user/coupon-record',
							name: '会员领券',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/user/coupon_record'], resolve),
							permission: [{
									name: '删除',
									url: '/vueadmin/user/coupon-record/del'
								},
								{
									name: '兑换',
									url: '/vueadmin/user/coupon-record/exchange'
								},
				
				
							]
						},
					]
				},
				
				{
					path: 'dis*',
					url: 'dis',
					name: '分销管理',
					open: false,
					iconCls: 'iconfont icon-e-distribution', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'list-info*',
							url: '/vueadmin/dis/list-info?status=1',
							name: '分销商管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/lists_info'], resolve),
							permission: [],

						},
						{
							path: 'lev*',
							url: '/vueadmin/dis/lev',
							name: '分销商等级',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/lev'], resolve),
							permission: [],

						},
						{
							path: 'lists*',
							url: '/vueadmin/dis/lists?status=0',
							name: '分销商审核',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/lists'], resolve),
							permission: [],

						},
						{
							path: 'come-in-lists*',
							url: '/vueadmin/dis/come-in-lists?status=1&type=0',
							name: '佣金明细',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/commission_lists'], resolve),
							permission: [],
						},
						{
							path: 'come-out-lists*',
							url: '/vueadmin/dis/come-out-lists?status=0',
							name: '提现审核',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/come_out_lists'], resolve),
							permission: [],
						},
						{
							path: 'config*',
							url: '/vueadmin/dis/config?status=0',
							name: '分销设置',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/dis/config'], resolve),
							permission: [],

						},


					]
				},
					{
					path: 'appointment*',
					url: 'appointment',
					name: '表单管理',
					open: false,
					iconCls: 'iconfont icon-e-excel', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'lists*',
							url: '/vueadmin/appointment/lists?status=0',
							name: '信息列表',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/appointment/lists'], resolve),
							permission: [],

						},
						{
							path: 'create*',
							name: '表单管理',
							permission: [],
							url: '/vueadmin/appointment/create',
							component: resolve => require(['../pages/system/form/create_edit'], resolve),
						}

					]
				},
				{
					path: 'integral*',
					url: 'integral',
					name: '积分商城',
					open: false,
					iconCls: 'iconfont icon-e-integral', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [

						{
							path: 'lists*',
							url: '/vueadmin/integral/lists',
							name: '积分奖品',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/integral/lists'], resolve),
							permission: [],
						},
						{
							path: 'order-lists*',
							url: '/vueadmin/integral/order-lists?status=3',
							name: '积分订单',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/integral/order_lists'], resolve),
							permission: [],
						},

						{
							path: 'order-info*',
							url: '/vueadmin/integral/order-info',
							name: '查看详情',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/integral/info'], resolve),
						},
						{
							path: 'create*',
							url: '/vueadmin/integral/create',
							name: '积分产品增加',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/integral/create_edit'], resolve),
						},
						{
							path: 'edit*',
							url: '/vueadmin/integral/edit',
							name: '积分产品修改',
							hidden: true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/shop/integral/create_edit'], resolve),
						}


					]
				},				

				{
					path: 'setting*',
					url: '/vueadmin/setting',
					name: '员工号管理',
					open: false,
					iconCls: 'iconfont icon-e-website', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [{
							path: 'merchant-lists*',
							url: '/vueadmin/setting/merchant/merchant-lists',
							name: '商家列表',
							hidden: false,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/merchant/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/setting/merchant/merchant-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/setting/merchant/merchant-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/setting/merchant/merchant-lists/edit'
							}, ]
						},
						{
							path: 'staff-lists*',
							url: '/vueadmin/setting/merchant/staff-lists',
							name: '员工管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/lists'], resolve),
							permission: [{
								name: '删除',
								url: '/vueadmin/setting/merchant/staff-lists/del'
							}, {
								name: '新建',
								url: '/vueadmin/setting/merchant/staff-lists/create'
							}, {
								name: '修改',
								url: '/vueadmin/setting/merchant/staff-lists/edit'
							}, ]
						},
						{
							path: 'staff-schedual*',
							url: '/vueadmin/setting/merchant/staff-schedual',
							name: '员工排班',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/schedual'], resolve),
							permission: [ ]
						},
						{
							path: 'staff-appointment*',
							url: '/vueadmin/setting/merchant/staff-appointment',
							name: '预约记录',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/appointment'], resolve),
							permission: [ ]
						},
						{
							path: 'staff-all-schedual*',
							url: '/vueadmin/setting/merchant/staff-all-schedual',
							name: '员工排班',
							hidden:true,
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/schedual-all'], resolve),
							permission: [ ]
						},
						{
							path: 'staff-role*',
							url: '/vueadmin/setting/merchant/staff-role',
							name: '员工角色与权限',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/role'], resolve),
							permission: [ ]
						},
						{
							path: 'connect*',
							url: '/vueadmin/setting/merchant/connect',
							name: '工作交接',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/connect'], resolve),
							permission: []
						},
						{
							path: 'message*',
							url: '/vueadmin/setting/merchant/message',
							name: '咨询管理',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/staff/message_record'], resolve),
							permission: []
						},
						{
							path: 'role*',
							url: '/vueadmin/setting/role',
							name: '商家角色列表',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/role/lists'], resolve),
							permission: []
						},

					]
				},
				{
					path: 'ldshop*',
					url: 'ldshop',
					name: '门店设置',
					open: false,
					iconCls: 'iconfont icon-e-shop-system', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [
						{
							path: 'lists*',
							url: '/vueadmin/ldshop/lists',
							name: '门店设置',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/decorate/shop/lists'], resolve),
							permission: []
						},
				
					]
				},
				{
					path: 'auth*',
					url: '/vueadmin/auth',
					name: '授权管理',
					open: false,
					iconCls: 'iconfont icon-e-authorize', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [{
							path: 'configForApp*',
							url: '/vueadmin/auth/configForApp',
							name: '小程序授权',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/system/configForApp'], resolve),
							permission: []
						},
						{
							path: 'configForCrop*',
							url: '/vueadmin/auth/configForCrop',
							name: '企业号授权',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/system/configForCrop'], resolve),
							permission: []
						},
					]
				},
				{
					path: 'system*',
					url: '/vueadmin/system',
					name: '系统管理',
					open: false,
					iconCls: 'iconfont icon-e-config', //图标样式class
					component: resolve => require(['../p'], resolve),
					children: [{
							path: 'config*',
							url: '/vueadmin/system/config',
							name: '基本设置',
							iconCls: 'iconfont icon8', //图标样式class
							component: resolve => require(['../pages/system/config'], resolve),
							permission: []
						},
						{
							path: 'password*',
							name: '修改密码',
							permission: [],
							url: '/vueadmin/system/password',
							component: resolve => require(['../pages/system/password'], resolve),
						},

					]
				},
			]
		},
		{
			path: '/login/index',
			name: 'login',
			hidden: true,
			component: resolve => require(['../pages/login/index'], resolve)
		},
		{
			path: '/test',
			name: 'test',
			hidden: true,
			component: resolve => require(['../pages/test'], resolve)
		},
		{
			path: '/login/ip-allow',
			name: 'login',
			hidden: true,
			component: resolve => require(['../pages/login/allow_ip'], resolve)
		},
		{
			path: '/publishCode/index',
			name: 'publishCode',
			hidden: true,
			component: resolve => require(['../pages/publishCode/index'], resolve)
		},

		{
			path: '/website/index',
			name: '微官网',
			hidden: true,
			component: resolve => require(['../pages/website/new/index'], resolve)
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js